import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      for (let i = 0; i < 20 && !cancelled; i++) {
        setTries(i + 1);
        try {
          const { data } = await api.get(`/payments/status/${sessionId}`);
          if (data.payment_status === "paid") { setStatus("paid"); return; }
          if (["expired", "failed"].includes(data.payment_status)) { setStatus(data.payment_status); return; }
        } catch (err) {
          console.warn("payment status poll error:", err);
        }
        await new Promise((r) => setTimeout(r, 2000));
      }
      if (!cancelled) setStatus("timeout");
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center">
      <div className="nb-card p-10">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin mx-auto text-[var(--coral)]" />
            <h1 className="text-3xl font-extrabold mt-4">Confirming payment…</h1>
            <p className="text-sm text-neutral-600 mt-1">Attempt {tries}/20</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[var(--mint)]" />
            <h1 className="text-4xl font-extrabold mt-3">You're in! 🎉</h1>
            <p className="text-neutral-600 mt-2">Your plan is active. Time to learn.</p>
            <Link data-testid="success-cta-dashboard" to="/dashboard" className="nb-btn mt-6 inline-flex">Go to dashboard</Link>
          </>
        )}
        {(status === "expired" || status === "failed" || status === "timeout") && (
          <>
            <h1 className="text-3xl font-extrabold">Something went off-track</h1>
            <p className="text-neutral-600 mt-2">Payment {status}. You can try again.</p>
            <Link to="/pricing" className="nb-btn mt-6 inline-flex">Back to pricing</Link>
          </>
        )}
      </div>
    </div>
  );
}
